fx.ns("shared.popups", class FileNotUploaded extends shared.popups.BasePersonPopup{
    
    constructor(photos, model)
    {
        super(photos, fx.get("assets").personNotHappy );

        this.images = photos;
        this.model = model;
       
        this.contentWidth = 550;
        this.contentHeight = 415;
        this.showClose = false;
    }

    get filesType()
    {
        if (!this._filesType)
        {
            for (let i = 0; i < this.images.length; i++)
            {
                let image = this.images.getItemAt(i);
                let className = Object.getPrototypeOf(image).constructor.name;
                if (!this._filesType)
                    this._filesType = className;
                else
                if (this._filesType != className)
                {
                    this._filesType = "";
                    break;
                }
            }
        }

        return this._filesType;
    }

    create()
    {
        super.create();
        
        this.addChild(new fx.components.Text({text:fx.text("Ces fichiers n'ont pu être transférées"), className:"title"}));

        let hscroll = new fx.components.Scrollable("horizontal", "relative");
        for (let i = 0; i < this.images.length; i++)
            hscroll.addChild(new fx.components.Image( {data : this.images[i], cover:true} ), {width:100, height:100});

        this.addChild( hscroll, { width:"100%", height:125});

        this.addChild(new fx.components.Text({text: fx.text("Vérifiez votre connexion Internet (signal wifi faible, cable déconnecté, téléchargements en cours...), ou assurez-vous que votre fichier est encore accessible (fichier supprimé, ou disque externe déconnecté)."), className:"text"}));

        this.okButton = new fx.components.Button({label : fx.text("Ré-essayer"), type : "filled"});
        this.cancelButton = new fx.components.Button({label : fx.text("Annuler")});

        this.addFooterChild(this.cancelButton, {width:200});
        this.addFooterChild(this.okButton, {width:220});
    }

    
    onReady()
    {
        super.onReady();

        this.on("click", this.onRetry, this.okButton);
        this.on("click", this.onCancel, this.cancelButton);
    }


    onRetry()
    {
        fx.service("MediasUploader").upload(this.images);
        this.close();
    }

    onCancel()
    {
        for (let i = 0; i < this.images.length; i++)
        {
            let image = this.images.getItemAt(i)
            if (image)
                image.delete(true);
        }
        
        this.model.event("failed-photos-canceled", this.images);
        this.close();
    }

});